module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/index.js
// module id = 1157
// module chunks = 25